import smoothscroll from 'smoothscroll-polyfill'

// Global
import './scripts/lazyloading'
import './scripts/labels'
import './scripts/vue'
import './scripts/breakpoints'
import './scripts/currency'
import './scripts/videos'
import './scripts/sliders'
import './scripts/quickshop'
import './scripts/swatches'

// Templates
import './scripts/product'

document.documentElement.className = document.documentElement.className.replace('no-js', 'js')

smoothscroll.polyfill()

// Re-run javascript on section updates in Theme Editor
// TODO: Use @shopify/theme-sections plugin to reload specific scripts
// document.addEventListener('shopify:section:load', (e) => {
//   let head = document.getElementsByTagName('head')[0]
//   let reloadScript = document.createElement('script')
//   reloadScript.src = document.querySelector('.custom-js').src + '?' + e.timeStamp
//   document.querySelector('.custom-js').remove()
//   reloadScript.classList.add('custom-js')
//   head.appendChild(reloadScript)
// })
